/* Estatus de la descarga en el módulo Descargas */
export const EN_PROCESO = {
  value: 0,
  label: 'En proceso'
};
export const TERMINADO = {
  value: 1,
  label: 'Terminado'
};
